import { Component, OnInit, Input } from '@angular/core';
import { JobOffersService } from '../../services/job-offers.service';

@Component({
  selector: 'app-kanban-timeline',
  templateUrl: './kanban-timeline.component.html',
  styleUrls: ['./kanban-timeline.component.css']
})
export class KanbanTimelineComponent implements OnInit {
  @Input() job;
  bars: any;
  loading: boolean;

  // bars = [
  //   {
  //     color: 'primary',
  //     mode : 'determinate',
  //     value : 100,
  //     bufferValue : 0,
  //     date: '01/01/2018',
  //     title: 'Inicio',
  //   },
  //   {
  //     color : 'accent',
  //     mode : 'determinate',
  //     value : 25,
  //     bufferValue : 75,
  //     date: '10/01/2018',
  //     title: 'Postulados',
  //   },
  //   {
  //     color : 'warn',
  //     mode : 'determinate',
  //     value : 0,
  //     bufferValue : 75,
  //     date: '15/01/2018',
  //     title: 'Pre-Seleccionados',
  //   },
  //   {
  //     color : 'warn',
  //     mode : 'determinate',
  //     value : 0,
  //     bufferValue : 75,
  //     date: '20/01/2018',
  //     title: 'Reporte',
  //   }
  // ];

  constructor(private jobService: JobOffersService) { 
    this.loading = true;
  }

  ngOnInit() {
    this.getLevelProfile();
  }

  getLevelProfile () {
    this.loading = true;
    this.jobService.getOffersLevelProfileUrl(this.job)
    .subscribe(
    data => {
      this.bars = data;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.bars = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.bars = undefined;
        this.loading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/kanban-timeline/kanban-timeline.component.ts